import React from 'react';

import { Badge } from '@/components/ui/badge';
import { cn } from '@/utils';

interface QcFeedbackReviewsCountBadgeProps {
  className?: string;
  count: number;
}

export const QcFeedbackReviewsCountBadge: React.FC<QcFeedbackReviewsCountBadgeProps> = ({
  className,
  count,
}) => (
  <Badge
    variant="outline"
    className={cn(
      'h-5 min-w-5 justify-center rounded-full px-1.5 py-0 text-[10px] leading-none shadow-none',
      count > 0
        ? 'border-notice-border bg-notice-muted text-notice-foreground'
        : 'border-border bg-muted text-muted-foreground',
      className,
    )}
  >
    {count}
  </Badge>
);
